var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cycles',{attrs:{"query":_vm.query,"noFilter":"","noCard":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }